/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useRef, useState } from 'react';
import { KYCDetails } from '../../Api';

const Kyc = () => {
  let kycObj = {
    companyName: "",
    companyAddress: "",
    name: "",
    partnerName: "",
    mobile: "",
    partnerMobile: "",
    officeMobile1: "",
    officeMobile2: "",
    residenceAddress: "",
    mail: "",
    bankName: "",
    branchName: "",
    accountNumber: "",
    ifsc: "",
    gstNumber: "",
    panNumber: "",
    reference: "",
    addressCopy: "",
    panCopy: "",
    gstCopy: "",
    partnershipCopy: "",
  };

  const [kycData, setKycData] = useState({ ...kycObj });
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

  let addressCopyRef = useRef(null);
  let panCopyRef = useRef(null);
  let gstCopyRef = useRef(null);
  let partnershipCopyRef = useRef(null);

  const validateFn = (type, value) => {
    let regex = type === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/ : (type === "mobile" && /^\d{10}$/);
    return regex?.test(value);
  };

  const onChangeFn = (key, value) => {
    let copyFields = ["addressCopy", "panCopy", "gstCopy", "partnershipCopy"];
    let tempKycData = { ...kycData };
    if (copyFields.includes(key) && !!value && !!value.target && value.target.files && value.target.files[0]) {
      var path = window.URL.createObjectURL(value.target.files[0]);
      tempKycData[key] = value.target.files[0];
      tempKycData[key]["path"] = path;
    } else {
      tempKycData[key] = value;
    }
    setKycData({ ...tempKycData });
  };

  const handleSubmit = useCallback(async () => {
    if (!disableSubmitBtn) {
      setDisableSubmitBtn(true);
      let isValid = true;
      if (!(!!kycData?.name)) {
        alert("Please enter Name");
        isValid = false;
        setDisableSubmitBtn(false);
      }
      else if (!(!!kycData?.mobile) || kycData?.mobile.charAt(0) === '0' || !validateFn("mobile", kycData?.mobile)) {
        alert("Please enter Mobile");
        isValid = false;
        setDisableSubmitBtn(false);
      }

      else if (!!kycData?.mail && !validateFn("mail", kycData?.mail)) {
        alert("Please enter valid mail");
        isValid = false;
        setDisableSubmitBtn(false);
      }
      if (!!isValid) {
        KYCDetails(kycData)
          .then((res) => {
            let { code, message, title } = res;
            if (code === 200) {
              setKycData({ ...kycObj });
              addressCopyRef.current.value = "";
              panCopyRef.current.value = "";
              gstCopyRef.current.value = "";
              partnershipCopyRef.current.value = "";
              setDisableSubmitBtn(false);
              alert(message);
            } else {
              alert(title);
              setDisableSubmitBtn(false);
            }
          });
      }
    }
  });

  return (
    <>
      <section className="kyc drive-cars-section">
        <center>
          <span id="lblmsg" style={{ color: "green", textAlign: "center", display: "none" }}/>
        </center>
        <div className="container">
        <div className="col-md-12">
  <div className="header">
    <div className="title-wth title-name">
      KYC
      <div className="mn-title-border">
        {/* <img src="images/border.png" alt=""> */}
      </div>
    </div>
  </div>
</div>

        <div>
          <p align="right" style={{ color: "#ff0000" }}>
            Fields in * are mandatory
          </p>
        </div>

          <div className="pad_bottom" id="frmkyc">
            {/* <div className="title-field">Company Details</div> */}
            <legend className="title-field"> Company Details</legend>
            <fieldset className="scheduler-border">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Company Name:</label>
                    <input
                      name="txtCompany1"
                      type="text"
                      id="txtCompany1"
                      className="form-control"
                      placeholder="Company Name"
                      value={kycData?.companyName}
                      onChange={(e) => onChangeFn('companyName', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Address:</label>
                    <textarea
                      name="txtAddress"
                      rows={2}
                      cols={20}
                      id="txtAddress"
                      className="form-control"
                      placeholder="Company Address"
                      value={kycData?.companyAddress}
                      onChange={(e) => onChangeFn('companyAddress', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="clearfix" />
            <legend className="title-field"> Proprietor/Partners</legend>
            <fieldset className="scheduler-border">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Name1<span style={{ color: "red" }}>*</span>:
                    </label>
                    <input
                      name="txtName1"
                      type="text"
                      id="txtName1"
                      className="form-control"
                      placeholder="Enter Name"
                      value={kycData?.name}
                      onChange={(e) => onChangeFn('name', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                    <span
                      id="RequiredFieldValidator1"
                      autopostback="false"
                      style={{ color: "Red", fontFamily: "Calibri", display: "none" }}
                    >
                      Name Required
                    </span>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Mobile1<span style={{ color: "red" }}>*</span>:
                    </label>
                    <input
                      name="txtMobile1"
                      type="text"
                      id="txtMobile1"
                      className="form-control"
                      placeholder="Enter Mobile"
                      maxLength={10}
                      value={kycData?.mobile}
                      onChange={(e) => {
                        const restrictDot = e.target.value.replace(/\D/g, '');
                        onChangeFn("mobile", restrictDot);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                    <span
                      id="RequiredFieldValidator2"
                      autopostback="false"
                      style={{ color: "Red", fontFamily: "Calibri", display: "none" }}

                    >
                      Mobile Required
                    </span>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Name2:</label>
                    <input
                      name="txtName2"
                      type="text"
                      id="txtName2"
                      className="form-control"
                      placeholder="Enter Name"
                      value={kycData?.partnerName}
                      onChange={(e) => onChangeFn('partnerName', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Mobile2:</label>
                    <input
                      name="txtMobile2"
                      type="text"
                      id="txtMobile2"
                      className="form-control"
                      placeholder="Enter Mobile"
                      value={kycData?.partnerMobile}
                      maxLength={10}
                      onChange={(e) => {
                        const restrictDot = e.target.value.replace(/\D/g, '');
                        onChangeFn("partnerMobile", restrictDot);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="clearfix" />
            <legend className="title-field"> Phone No</legend>
            <fieldset className="scheduler-border">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Office1:</label>
                    <input
                      name="txtOffice1"
                      type="text"
                      id="txtOffice1"
                      className="form-control"
                      placeholder="Enter Office Number"
                      value={kycData?.officeMobile1}
                      maxLength={10}
                      onChange={(e) => {
                        const restrictDot = e.target.value.replace(/\D/g, '');
                        onChangeFn("officeMobile1", restrictDot);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Office2:</label>
                    <input
                      name="txtOffice2"
                      type="text"
                      id="txtOffice2"
                      className="form-control"
                      placeholder="Enter Office Number"
                      value={kycData?.officeMobile2}
                      maxLength={10}
                      onChange={(e) => {
                        const restrictDot = e.target.value.replace(/\D/g, '');
                        onChangeFn("officeMobile2", restrictDot);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Residence:</label>
                    <input
                      name="txtResidence"
                      type="text"
                      id="txtResidence"
                      className="form-control"
                      placeholder="Enter Residence"
                      value={kycData?.residenceAddress}
                      onChange={(e) => onChangeFn('residenceAddress', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Email:</label>
                    <input
                      name="txtEmail"
                      type="text"
                      id="txtEmail"
                      className="form-control"
                      placeholder="Enter Email"
                      value={kycData?.mail}
                      onChange={(e) => onChangeFn('mail', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="clearfix" />
            <legend className="title-field">Bank Details</legend>
            <fieldset className="scheduler-border">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Name:</label>
                    <input
                      name="txtBankName"
                      type="text"
                      id="txtBankName"
                      className="form-control"
                      placeholder="Enter Name"
                      value={kycData?.bankName}
                      onChange={(e) => onChangeFn('bankName', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Branch:</label>
                    <input
                      name="txtBranch"
                      type="text"
                      id="txtBranch"
                      className="form-control"
                      placeholder="Enter Branch"
                      value={kycData?.branchName}
                      onChange={(e) => onChangeFn('branchName', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Account Number:</label>
                    <input
                      name="txtAccountNumber"
                      type="text"
                      id="txtAccountNumber"
                      className="form-control"
                      placeholder="Enter Account Number"
                      value={kycData?.accountNumber}
                      onChange={(e) => onChangeFn('accountNumber', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">IFSC Code:</label>
                    <input
                      name="txtIFSCCode"
                      type="text"
                      id="txtIFSCCode"
                      className="form-control"
                      placeholder="Enter IFSC Code"
                      value={kycData?.ifsc}
                      onChange={(e) => onChangeFn('ifsc', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">GST No:</label>
                    <input
                      name="txtGSTNo"
                      type="text"
                      id="txtGSTNo"
                      className="form-control"
                      placeholder="Enter GST No."
                      value={kycData?.gstNumber}
                      onChange={(e) => onChangeFn('gstNumber', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">PAN No:</label>
                    <input
                      name="txtPANNo"
                      type="text"
                      id="txtPANNo"
                      className="form-control"
                      placeholder="Enter PAN No."
                      value={kycData?.panNumber}
                      onChange={(e) => onChangeFn('panNumber', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Reference:</label>
                    <input
                      name="txtReference"
                      type="text"
                      id="txtReference"
                      className="form-control"
                      placeholder="Enter Reference"
                      value={kycData?.reference}
                      onChange={(e) => onChangeFn('reference', e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="clearfix" />
            <legend className="title-field"> Documents Required</legend>
            <fieldset className="scheduler-border">
              <div className="row">
              <div className="col-md-6 col-sm-6 col-xs-6">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">
                    1 Address Proof Scan Copy:
                  </label>
                  <input type="file" name="fuAddress" id="fuAddress"
                    ref={addressCopyRef}
                    onChange={(e) => { onChangeFn('addressCopy', e); }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">2. Pan No Scan Copy:</label>
                  <input type="file" name="fuPANNo" id="fuPANNo"
                    ref={panCopyRef}
                    onChange={(e) => onChangeFn('panCopy', e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">3. GST No Scan Copy:</label>
                  <input type="file" name="fuGSTNo" id="fuGSTNo"
                    ref={gstCopyRef}
                    onChange={(e) => onChangeFn('gstCopy', e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">
                    4. Partnership Deed Copy:
                  </label>
                  <input type="file" name="fuPartnership" id="fuPartnership"
                    ref={partnershipCopyRef}
                    onChange={(e) => onChangeFn('partnershipCopy', e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
              </div>
              </div>
            </fieldset>
            <div className="clearfix" />
            <div id="msgForSubmit" className="alert alert-success alert-autocloseable-success" style={{ display: "none" }}/>
            <div
              style={{
                display: "block",
                textAlign: "center",
                float: "left",
                width: "100%"
              }}>
              <input
                type="submit"
                name="btnKycRegister"
                defaultValue="SUBMIT"
                disabled={disableSubmitBtn}
                onClick={() => handleSubmit()}
                style={{ background: disableSubmitBtn ? 'gray' : '' }}
                id="btnKycRegister"
                className="kyc-btn pull-right"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Kyc;
